var map = {
	"./alto/first.jpeg": 646,
	"./baixoclaro/first.jpeg": 647,
	"./baixoescuro/first.jpeg": 648,
	"./medio/first.jpeg": 649,
	"./medioalto/first.jpeg": 650,
	"./mediobaixo/first.jpeg": 651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 645;